import React, { useState } from 'react';
import AdultDrugCalculator from './AdultDrugCalculator';
import PediatricDrugCalculator from './PediatricDrugCalculator';
import './drug-calculator.css';

export default function DrugCalculator({ onOpenProtocols }) {
  const [mode, setMode] = useState('adult');

  return (
    <div className="drugcalc-unified">
      <section className="drugcalc-card" style={{ marginBottom: 14 }}>
        <span className="drugcalc-kicker">LINE MEDIC MEDICATION CALCULATOR</span>
        <h3>Adult + Pediatric</h3>
        <p>Select the patient population before entering a dose. Adult and pediatric rules are kept as separate verified rule sets.</p>
        <div className="drugcalc-dose-chips" role="group" aria-label="Patient population">
          <button type="button" className={`drugcalc-secondary${mode === 'adult' ? ' active' : ''}`} aria-pressed={mode === 'adult'} onClick={() => setMode('adult')}>Adult</button>
          <button type="button" className={`drugcalc-secondary${mode === 'pediatric' ? ' active' : ''}`} aria-pressed={mode === 'pediatric'} onClick={() => setMode('pediatric')}>Pediatric</button>
        </div>
      </section>
      {mode === 'adult'
        ? <AdultDrugCalculator onOpenProtocols={onOpenProtocols} />
        : <PediatricDrugCalculator onOpenProtocols={onOpenProtocols} />}
    </div>
  );
}
